module.exports = __webpack_public_path__ + "static/media/doctor-management-system-clinical-dashboard-healthcare.857702c8.webp";